module.exports = __webpack_public_path__ + "static/media/intro-1.d7f98549.svg";